<main class="billing-management-page">
  <div class="page-shell">
    <header class="page-header app-card">
      <div>
        <h1>Billing Management</h1>
        <span>Review weekly QCA billing amounts by financial year.</span>
      </div>
      <div class="filter-grid ms-auto">
        <div>
          <label class="filter-field" for="financial-year">
            <select id="financial-year" class="app-form-select" [value]="selectedFinancialYear()" (change)="changeFinancialYear($any($event.target).value)">
              @for (financialYear of financialYears; track financialYear) {
                <option [value]="financialYear">{{ financialYear }}</option>
              }
            </select>
          </label>
        </div>
        <div>
          <label class="filter-field" for="billing-week">
            <select id="billing-week" class="app-form-select" [value]="selectedWeek()" (change)="selectedWeek.set($any($event.target).value)">
              @for (week of weeks(); track week.id) {
                <option [value]="week.id" [selected]="week.id === selectedWeek()">{{ week.label }}</option>
              }
            </select>
          </label>
        </div>
        <div class="filter-actions">
          <button type="button" class="app-button app-button--primary" (click)="search()">Search</button>
          <button type="button" class="app-button app-button--secondary" (click)="reset()">Reset</button>
        </div>
      </div>
    </header>


    <section class="stats-grid" aria-label="Billing summary">
      <article class="stat-card app-card tone-blue">
        <div class="stat-icon">⌘</div>
        <div class="stat-copy"><span>Total QCAs</span><strong>{{ totalQcas() }}</strong></div>
      </article>
      <article class="stat-card app-card tone-green">
        <div class="stat-icon">₹</div>
        <div class="stat-copy"><span>Total Amount</span><strong>{{ totalAmount() | currency: 'INR': 'symbol': '1.0-0' }}</strong></div>
      </article>
      <article class="stat-card app-card tone-violet">
        <div class="stat-icon">◷</div>
        <div class="stat-copy"><span>Current Week</span><strong class="week-number">{{ selectedWeekLabel().split(':')[0] }}</strong></div>
      </article>
    </section>

    <section class="table-card app-card">


      <div class="table-wrap">
        <table class="qca-table">
          <thead>
            <tr>
              <th scope="col" rowspan="2">QCA Name</th>
              <th scope="col" colspan="3" class="text-center">Intra-State Transactions</th>
              <th scope="col" colspan="2" class="text-center">Inter-State Transactions</th>
              <th scope="col" rowspan="2">Total</th>
            </tr>
            <tr>
              <th scope="col">Deviation Charges @ PSS level (Rs.)<br>Payable to Pool (c)</th>
              <th scope="col">Deviation Charges @ State Periphery (Rs.)<br>Payable to Pool (d)</th>
              <th scope="col">Receivable from Pool (e)</th>
              <th scope="col">Deviation Charges @ PSS level (Rs.)<br>Payable to Pool (f)</th>
              <th scope="col">Receivable from Pool (g)</th>
            </tr>
          </thead>
          <tbody>
            @for (row of paginatedRows(); track row.qcaId) {
              <tr>
                <td>
                  @if (row.qcaId === null) {
                    <span class="text-secondary">{{ row.qcaName }}</span>
                  } @else {
                    <button class="table-link name-link" type="button" (click)="selectCompany(row)">
                      {{ row.qcaName }}
                    </button>
                  }
                </td>
                <td class="amount-cell">{{ row.payableAtPss | currency: 'INR': 'symbol': '1.2-2' }}</td>
                <td class="amount-cell">{{ row.payableToPool | currency: 'INR': 'symbol': '1.2-2' }}</td>
                <td class="amount-cell">{{ row.receivableFromPool | currency: 'INR': 'symbol': '1.2-2' }}</td>
                <td class="amount-cell">{{ row.interPayableToPool | currency: 'INR': 'symbol': '1.2-2' }}</td>
                <td class="amount-cell">{{ row.interReceivableFromPool | currency: 'INR': 'symbol': '1.2-2' }}</td>
                <td class="amount-cell">{{ rowTotal(row) | currency: 'INR': 'symbol': '1.2-2' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <footer class="table-footer">
        <span>{{ showingText() }}</span>
        <div class="pagination" aria-label="Billing table pagination">
          <button type="button" class="page-button" aria-label="Previous page" [disabled]="currentPage() === 1" (click)="goToPage(currentPage() - 1)">‹</button>
          @for (page of pageNumbers(); track page) {
            <button type="button" class="page-button" [class.active]="page === currentPage()" (click)="goToPage(page)">{{ page }}</button>
          }
          <button type="button" class="page-button" aria-label="Next page" [disabled]="currentPage() === totalPages()" (click)="goToPage(currentPage() + 1)">›</button>
        </div>
      </footer>
    </section>
  </div>
</main>
